<template>
    <div class="loader contacts-loading">
        <div class="list-info"><span>{{Language.say(props.text)}}</span></div>

        <div class="list-wrapper">
            <div v-for="n in 10" :key="'cn_l_' + n" class="contact">
                <div class="checkbox">
                    <input type="checkbox">
                    <label></label>
                </div>
                <div class="meta">
                    <span class="name"></span>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import Language        from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    text : {
      default : 'contacts.loading',
    },
  })
</script>
